import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  makeStyles,
  SvgIcon,
  Divider,
  Typography,
} from '@material-ui/core';
import { Menu as MenuIcon } from 'react-feather';
import Logo from 'components/Logo';
import Logout from './Logout';
import { useReactOidc } from '@axa-fr/react-oidc-context';
import Info from './Info';

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    boxShadow: 'none',
    backgroundColor: theme.palette.primary.main,
  },
  divider: {
    backgroundColor: '#ffffff',
    marginTop: 15,
    marginBottom: 15,
  },
  toolbar: {
    minHeight: 64,
  },
}));

const TopBar = ({ className, onMobileNavOpen, ...rest }) => {
  const classes = useStyles();
  const { logout } = useReactOidc();

  return (
    <AppBar className={clsx(classes.root, className)} {...rest}>
      <Toolbar className={classes.toolbar}>
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onMobileNavOpen}>
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        </Hidden>
        <Hidden mdDown>
          <RouterLink to="/">
            <Logo height="35" style={{ color: '#fff' }} />
          </RouterLink>
          <Divider
            component="div"
            orientation="vertical"
            variant="middle"
            flexItem
            className={classes.divider}
          />
          <Typography variant="h4">Dashboard</Typography>
        </Hidden>
        <Box ml={2} flexGrow={1} />
        <Info />
        <Logout
          doLogOut={() => {
            logout();
          }}
        />
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func,
};

TopBar.defaultProps = {
  onMobileNavOpen: () => {},
};

export default TopBar;
